import { render } from "./BpCoordBar.vue?vue&type=template&id=46d4f857&scoped=true"
import script from "./BpCoordBar.vue?vue&type=script&lang=js"
export * from "./BpCoordBar.vue?vue&type=script&lang=js"

import "./BpCoordBar.vue?vue&type=style&index=0&id=46d4f857&scoped=true&lang=css"

import exportComponent from "/home/grosscol/workspace/bravue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d4f857"]])

export default __exports__